<!DOCTYPE html>
<template>
  <div class="doc-detail">
    <!-- Creation date subtitle -->
    <p class="doc-detail__date text-muted small mb-3">Created {{ document.createdDate }}</p>

    <div class="row align-items-start">
      <!-- Metadata table — left side -->
      <div class="col-md-8">
        <b-table
          id="metadata_table"
          striped
          hover
          responsive
          :items="document.metadataDTO"
          :fields="metadataFields"
          show-empty
          empty-text="No metadata entries recorded."
        />
      </div>

      <!-- QR code — right side -->
      <div class="col-md-4 text-center">
        <img
          v-if="qrURL"
          :src="qrURL"
          :alt="'QR code for ' + document.companyName"
          class="doc-detail__qr img-fluid"
        />
        <p class="small text-muted mt-1">Scan to verify</p>
      </div>
    </div>

    <!-- Share with colleagues -->
    <div class="doc-detail__share mt-4 pt-3 border-top">
      <h3 class="h5 mb-3">Share Document</h3>
      <b-form @submit.prevent="shareDocument">
        <b-form-group label="Share with colleagues in your organization:">
          <b-form-checkbox-group v-model="shareTo" stacked>
            <b-form-checkbox
              v-for="user in userList"
              :key="user.uid"
              :id="'user-' + user.uid"
              :value="user.uid"
            >
              {{ user.firstName }} {{ user.lastName }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-button type="submit" variant="primary" :disabled="!shareTo.length">
          Share Document
        </b-button>
      </b-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.doc-detail__date {
  color: var(--secudoc-on-surface-variant);
}

.doc-detail__qr {
  /* The framed QR (qr-frame-mark-empty.svg) already supplies its own card + border,
     so no extra border/padding here — that would double up around the frame. */
  max-width: 160px;
}

.doc-detail__share h3 {
  color: var(--secudoc-on-surface);
}
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import { renderFramedQr } from "@/utils/framedQr";
	import axios from "axios";
	const config = require("../firebaseconfig.js");
	
	class Document {
		constructor() {
		
		}
	}
	class User {
		constructor () {
		
		}
	}

	export default {
		name: "view-document",
		props: {
			uid: {
				type: String
			},
		},
		methods: {
			/*
				TODO: Share Documents to Professionals in Organization
					1. Show modal window with list of users the document is share to
						a. close document modal window when share modal window is present
						b. re-open document modal window when share modal window is closed
					2. Add textbar to enter user's name
						a. auto complete should show list of users based on query
					3. Add button to persist share API call for value in textbar
					4. Close modal window when API returned successful response
						a. show error (do not close modal window) if there's error
			*/
			showShareToUI() {
				console.log("opening modal window");
			},
			shareDocument() {
				var documentId = this.uid;
				var owner = firebase.auth().currentUser.uid;
				var req = {
					documentId: documentId,
					owner: owner,
					shareTo: this.shareTo
				};
				axios.post(config.functionBaseUrl + "/shareTo", req)
					.then(response => {
						//TODO: update dashboard list
						this.$bvToast.toast('Document shared successfully', {
							title: 'Success', variant: 'success', solid: true, autoHideDelay: 4000
						});
						return;
					}).catch(error => {
						console.error("error  " + error);
						this.$bvToast.toast('Failed to share document', {
							title: 'Error', variant: 'danger', solid: true, noAutoHide: true
						});
					}
				);
			}
		},
		mounted() {
			firebase.firestore().collection("Documents").doc(firebase.auth().currentUser.uid)
				.collection("Metadata").doc(this.uid).get().then(documentSnapshot => {
					var data = documentSnapshot.data();
					var doc = new Document();
					doc.uid = this.uid;
					doc.companyName = data.companyName;
					doc.createdDate = data.createdDate.toDate().toLocaleDateString("en-US");
					doc.metadataDTO = [];
					
					for (var key in data.metadata) {
						var metadata = new Object();
						metadata.account_property = key;
						metadata.value = data.metadata[key];
						doc.metadataDTO.push(metadata);
					}
					
					renderFramedQr(this.uid)
						.then(framedUrl => { this.qrURL = framedUrl; })
						.catch(error => { console.error(error); });
					this.document = doc;
					return firebase.firestore().collection("Users").doc(firebase.auth().currentUser.uid).get();
				}).then(userRecord => {
					var user = userRecord.data();
					return firebase.firestore().collection("Users")
						.where("organizationName", "==", user.organizationName)
						.where("role", "==", 2).get();
				}).then(usersRecord => {
					if (!usersRecord.empty) {
						usersRecord.forEach(result => {
							if (firebase.auth().currentUser.uid != result.id) {
								var user_ = result.data();
								var user = new User();
								user.uid = result.id;
								user.firstName = user_.firstName;
								user.middleName = user_.middleName;
								user.lastName = user_.lastName;
								user.birthdate = user_.birthdate;
								user.prcId = user_.prcId;
								user.fullAddress = user_.fullAddress;
								user.role = user_.role;
					
								this.userList.push(user);
							}
						});
					} else {
						//show error no other users present
						console.error("error, empty collection");
					}
				});

		},
		data() {
			return {
				document : {qrURL : ""},
				qrURL : "",
				userList : [],
				shareTo : [],
				modalUid : null,
				metadataFields: [
					{ key: 'account_property', label: 'Property' },
					{ key: 'value', label: 'Value' }
				],
			}
		}
	}
</script>

